const countryMap = {
  br: 'Brasil',
  us: 'United States',
  uk: 'United Kingdom',
  mx: 'México',
}

export default countryMap
